export default __webpack_public_path__ + "static/media/topImage.0fcdad5b.jpg";